// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__TCNfh","bigColWidth":"Table_bigColWidth__D68LM","biggerColWidth":"Table_biggerColWidth__3YoNo","row":"Table_row__3mz6B","col":"Table_col__2jt40"};